export const formatContract = (address: string) => {
  return address.replace(/^(.{10}).*?(.{0,10})$/, `$1${address.length > 20 ? '...' : ''}$2`);
};
